// Module
var code = "<section class=\"projects-list page-detail-wrapper\"> <div class=\"page-detail\"> <span></span><span></span><span></span><span></span><span></span> </div> <ul data-projects-list class=\"projects-list-wrap\"> </ul> </section>";
// Exports
export default code;